import { Box, Grid, IconButton, Stack, Tooltip, Typography, useTheme } from "@mui/material"
import { stringFormatter } from "src/utils/formatters"
import { fileFormatter } from "src/utils/formatters/fileFormatter"
import { FileObjectWRC } from "../api/get-archivos"
import { HttpFiles } from "src/http/files/httpFiles"
import { downloadFileBlobHelper } from "src/utils/helpers"
import DeleteIcon from '@mui/icons-material/Delete';
import toast from "react-hot-toast"
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog"

export const Documentacion = ({ archivos, refetch }: { archivos: FileObjectWRC[], refetch: () => void }) => {

    const theme = useTheme()

    const handleDownloadFile = (idFile: number) => {

        const promise = HttpFiles.download(idFile)

        toast.promise(promise, {
            loading: 'Buscando archivo',
            error: 'Error al descargar archivo',
            success: 'Archivo listo para descarga'
        })
            .then(res => {
                console.log('file: ', res)
                downloadFileBlobHelper(res)
            })
            .catch(e => console.log('error: ', e))
    }

    const handleDeleteFile = (idFile: number) => {
        const promise = HttpFiles.delete(idFile)

        toast.promise(promise, {
            loading: 'Eliminando archivo',
            error: 'Error al eliminar archivo',
            success: 'Archivo eliminado'
        }).then(refetch)
    }

    const { askConfirmation } = useConfirmationDialog()

    return (
        <Grid container spacing={4}>
            {
                archivos.map(archivo => (
                    <Grid item xs={12} sm={4} md={3} lg={2} key={archivo.nombreArchivo}>
                        <Stack
                            sx={{
                                borderRadius: theme.spacing(4),
                                background: '#E7F6FD',
                                boxShadow: theme.shadows[1],
                                ":hover": {
                                    boxShadow: theme.shadows[0]
                                },
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Box alignSelf='end' mb={-6}>
                                <Tooltip title='Eliminar'>
                                    <IconButton
                                        color='error'
                                        onClick={
                                            () => askConfirmation(() => handleDeleteFile(archivo.id),
                                                `¿Está seguro que desea eliminar ${archivo.nombreArchivo}?`
                                            )}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Tooltip title={`Descargar ${archivo.nombreArchivo}`}>
                                <Stack
                                    onClick={() => handleDownloadFile(archivo.id)}
                                    sx={{
                                        padding: theme.spacing(4),
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                    }}
                                    spacing={2}
                                >

                                    {fileFormatter.getIconByFileName(archivo.nombreArchivo, { fontSize: 'large' })}
                                    <Typography variant='subtitle2'>{stringFormatter.cutIfHaveMoreThan(archivo.nombreArchivo, 12)}</Typography>
                                </Stack>
                            </Tooltip>
                        </Stack>
                    </Grid>
                ))
            }
        </Grid>
    )
}
